// Ofertas: precio_oferta (rebajado) manda sobre precio_venta cuando es válido.
export const enOferta = (p) =>
  !!p && p.precio_oferta != null && Number(p.precio_oferta) > 0 && Number(p.precio_oferta) < Number(p.precio_venta);

export const precioEfectivo = (p) => (enOferta(p) ? Number(p.precio_oferta) : Number(p?.precio_venta || 0));

export const pctOferta = (p) =>
  enOferta(p) ? Math.round((1 - Number(p.precio_oferta) / Number(p.precio_venta)) * 100) : 0;
